import React from 'react';
import { useTranslation } from 'react-i18next';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { trDisplay, trTemplate } from '../../i18n';
import { SWRHelp, SWRHelpContent } from './SWRHelp';
import { SWR_STRATEGY_HELP, SWR_STRATEGY_HELP_SECTIONS } from './swrHelpContent';
import {
  SWR_WITHDRAWAL_STRATEGIES,
  normalizeSWRWithdrawalStrategy,
} from '../../lib/simulation/swrWithdrawalStrategies';

function StrategyExplanation({ strategy }) {
  useTranslation();
  const copy = SWR_STRATEGY_HELP[strategy.id];
  return <div data-swr-strategy-help={strategy.id}>
    <SWRHelpContent title={strategy.label} meaning={copy.meaning} usage={copy.usage}
      details={<dl className="space-y-2">
        {SWR_STRATEGY_HELP_SECTIONS.map(([field, label]) => <div key={field}>
          <dt className="font-semibold">{trDisplay(label)}</dt>
          <dd>{trDisplay(copy[field])}</dd>
        </div>)}
      </dl>} />
  </div>;
}

export default function SWRWithdrawalStrategySelector({ value, onChange }) {
  useTranslation();
  const selected = SWR_WITHDRAWAL_STRATEGIES.find(strategy => strategy.id === value.id);

  return <div className="space-y-3">
    <p id="swr-strategy-choice-hint" className="text-sm text-muted-foreground">{trDisplay('Scegli una strategia. La configurazione personalizzata mantiene tutti i controlli manuali.')}</p>
    <RadioGroup.Root required name="swr-withdrawal-strategy" value={value.id} onValueChange={id => onChange(normalizeSWRWithdrawalStrategy({ id, version: selected.version, parameters: {} }))}
      aria-label={trDisplay('Strategia di decumulo')} aria-describedby="swr-strategy-choice-hint" className="grid gap-2">
      {SWR_WITHDRAWAL_STRATEGIES.map(strategy => <div key={strategy.id} className="flex items-center gap-2">
        <RadioGroup.Item value={strategy.id}
        data-testid={`swr-strategy-${strategy.id}`}
        className="flex min-h-11 min-w-0 flex-1 items-center gap-2 rounded-md border border-border bg-background px-3 py-2 text-left text-sm text-foreground transition-colors hover:bg-muted active:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[state=checked]:border-blue-600 data-[state=checked]:bg-blue-50">
        <span aria-hidden="true" className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-current">
          <RadioGroup.Indicator className="h-2 w-2 rounded-full bg-blue-600" />
        </span>
        <span>{trDisplay(strategy.label)}</span>
        </RadioGroup.Item>
        <div data-testid={`swr-strategy-help-${strategy.id}`} className="shrink-0">
          <SWRHelp content={<StrategyExplanation strategy={strategy} />} side="right" buttonTrigger delayDuration={350}
            contentClassName="max-h-[min(76vh,42rem,var(--radix-popper-available-height))] max-w-[min(20rem,var(--radix-popper-available-width))] sm:max-w-[min(24rem,var(--radix-popper-available-width))]"
            triggerLabel={trTemplate('Informazioni sulla strategia: {{name}}', { name: trDisplay(strategy.label) })}
            triggerClassName="h-11 w-11 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted active:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            iconClassName="h-4 w-4" />
        </div>
      </div>)}
    </RadioGroup.Root>
  </div>;
}
